import type { ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const Skeleton = ({ className, ...props }: ComponentPropsWithoutRef<'span'>) => (
    <span {...props} className={classNames(styles.skeleton, className)} aria-hidden="true" />
);
